// extracted by mini-css-extract-plugin
module.exports = {"noOrdersContainer":"RecallHistory-noOrdersContainer-KOEzV","listSelected":"RecallHistory-listSelected-xu0Lw","listNotSelected":"RecallHistory-listNotSelected-zQ+pZ"};